import { createContext, useState } from 'react';
import { IFilterItem } from '../../data-types/filterItem';

export interface IReportsTableFilteringValues {
    folderFilterName: string;
    selectedFolderFilter: IFilterItem | null | undefined;
    setSelectedFolderFilter: (filter: IFilterItem | null) => void;
    clearAllFilters: () => void;
}

export const ReportsTableFilteringContext = createContext<IReportsTableFilteringValues | null>(null);

export function ReportsTableFilteringContextProvider(props: { value?: IReportsTableFilteringValues; children?: React.ReactNode }) {
    const folderFilterName = 'folderName';
    const [selectedFolderFilter, setSelectedFolderFilter] = useState<IFilterItem | null>();

    const clearAllFilters = () => {
        setSelectedFolderFilter(null);
    };

    return (
        <ReportsTableFilteringContext.Provider
            value={
                props.value ?? {
                    folderFilterName,
                    selectedFolderFilter,
                    setSelectedFolderFilter,
                    clearAllFilters,
                }
            }
        >
            {props.children}
        </ReportsTableFilteringContext.Provider>
    );
}
